import { ACTION } from "@/lib/auth/actions";
import { ROLE } from "@/lib/auth/roles";
import { hasPermission } from "@/lib/authv2/permissions";

/**
 * Màn "Phòng Kinh doanh" (QĐ 0483): cùng cổng với cửa máy chủ
 * `sales.structure.read`. Ai thấy tiểu đội nào, ai thấy lương cứng người khác
 * là việc của MÁY CHỦ (13a) — màn chỉ vẽ cái máy chủ trả.
 */
export function canSeeSalesTeam(): boolean {
  return hasPermission(ACTION.SalesStructureRead);
}

// Phòng sale / CSKH và CẢ phòng Kế toán (CEO 22a, 28/10/2026) — gương của
// `salesorg.CanRead` (`salesDept` + `accountingDept`).
const READER_DEPTS = new Set(["sale", "sales", "cskh", "accounting"]);

type StaffLike = { role?: string | null; department?: string | null } | null | undefined;

/**
 * Thẻ "Ghi công" trên chi tiết đơn: quản trị, giám đốc, cả phòng Kế toán và người
 * phòng sale / CSKH — cùng tập người máy chủ cho vào màn Phòng Kinh doanh. Thợ chụp,
 * lễ tân… không có việc gì ở thẻ này nên không bày ra cho họ. `canReadSales` =
 * `usePermission(ACTION.SalesStructureRead)` của màn gọi (đọc theo kiểu hook để
 * thẻ tự hiện / ẩn khi phiên đổi).
 */
export function canSeeOrderSalesCredits(staff: StaffLike, canReadSales: boolean): boolean {
  if (!staff || !canReadSales) return false;
  const role = (staff.role || "").toLowerCase().trim();
  if (role === ROLE.Admin || role === ROLE.Director || role === ROLE.Accounting || role === ROLE.Sale) return true;
  return READER_DEPTS.has((staff.department || "").toLowerCase().trim());
}
